import {
  AfterViewInit,
  Component,
  Inject,
  OnInit,
  ViewChild,
} from "@angular/core";
import { MatSnackBar } from "@angular/material";
import { HttpClient } from "@angular/common/http";
import { ListingComponent } from "../../dashboard/listing/listing.component";
import { environment } from "./../../../environments/environment";

/**
 * Seção "Faturas anteriores a 2024" do seller — SOMENTE LISTAGEM.
 *
 * A base nova não tem faturas criadas antes de 2024-02; essas vêm do banco mandae
 * legado via GET {URL_SERVICO_FISCAL}/v2/faturas-antigas (seller-bff → bff-billing
 * → middleware-xd-services), que resolve o cliente pelo token (user.getId()).
 *
 * Downloads (boleto/PDF/CSV) foram REMOVIDOS: os serviços legados que serviam
 * esses documentos (gerar-arquivos-fatura-service, cliente-services, boleto-services)
 * estão desativados/morrendo e retornavam 422. A internalização desses documentos
 * no middleware-xd-services está planejada à parte. Por ora, tabela informativa.
 */
@Component({
  selector: "mandae-invoice-list-legacy",
  templateUrl: "./invoice-list-legacy.component.html",
  styleUrls: ["./invoice-list.component.scss"],
})
export class InvoiceListLegacyComponent implements OnInit, AfterViewInit {
  public loading = false;

  public todas: any[] = [];
  public data: any[] = [];
  public pages = 0;

  public displayedColumns = [
    "numero",
    "value",
    "valorPago",
    "data_hora_criacao",
    "data_vencimento",
    "data_pagamento",
    "status",
  ];

  @ViewChild(ListingComponent) private listing: ListingComponent;

  private URL_FATURAS_CLIENTE: string =
    environment.angularJSconstants.URL_SERVICO_FISCAL;

  constructor(
    @Inject(HttpClient) protected http: HttpClient,
    private matSnackBar: MatSnackBar
  ) {}

  ngOnInit() {
    this.loading = true;
    this.http
      .get<any[]>(`${this.URL_FATURAS_CLIENTE}/v2/faturas-antigas`, {
        responseType: "json",
      })
      .subscribe(
        (response) => {
          this.todas = response || [];
          this.recalcularPaginacao();
          this.loading = false;
        },
        () => {
          this.todas = [];
          this.data = [];
          this.loading = false;
          this.matSnackBar.open(
            "Não foi possível carregar as faturas anteriores a 2024",
            "",
            { duration: 3000 }
          );
        }
      );
  }

  ngAfterViewInit() {
    if (this.listing) {
      this.listing.currentPageChange.subscribe(() => this.recalcularPaginacao());
      this.listing.currentLimitChange.subscribe(() => {
        this.listing.currentPage = 1;
        this.recalcularPaginacao();
      });
    }
  }

  private recalcularPaginacao() {
    const limit = this.listing ? this.listing.currentLimit : 10;
    const pagina = this.listing ? this.listing.currentPage : 1;
    this.pages = Math.max(1, Math.ceil(this.todas.length / limit));
    const inicio = (pagina - 1) * limit;
    this.data = this.todas.slice(inicio, inicio + limit);
  }

  public isEmptyDatasource() {
    return !this.data || this.data.length === 0;
  }

  public getInvoiceStatusClass(element): string {
    switch (element.situacaoCodigo) {
      case 3:
        return "tag status-success";
      case 4:
        return "tag status-danger";
      case 5:
      case 6:
        return "tag status-warning";
      default:
        return "tag status-info";
    }
  }
}
